/**
 * [Fecha formateada DD/MM/AAAA]
 * @param {string} date [fecha]
 */
export function dateFormat(date) {
  const formatted = date
    .toString()
    .slice(0, 10)
    .split("-")
    .reverse()
    .join("/");

  return formatted;
}

export function getHourFormat(date) {
  const hour = date.toString().slice(-8);

  return hour;
}

/**
 * [Segundos formateado a HH:MM:SS]
 * @param {string} seconds [segundos]
 */
export function secondsToTimeFormat(seconds) {
  if (!Date.parse(seconds)) return "";
  let date = new Date(null);
  date.setSeconds(seconds);
  let result = date.toISOString().substr(11, 8);

  // let result2 = result.split(":");

  // result2[0] = result2[0] + "h";
  // result2[1] = result2[1] + "m";
  // result2[2] = result2[2] + "s";

  // return result2.join(" ");
  return result;
}

/**
 * [HH:MM:SS formateado a 00h 00m 00s]
 * @param {string} seconds [segundos]
 */
export function HumanTimeFormat(time) {
  let result = time.split(":");

  result[0] = result[0] + "h";
  result[1] = result[1] + "m";
  result[2] = result[2] + "s";

  result = result.filter((value) => !value.startsWith("00"));

  return result.join(" ");
  // return result;
}

/**
 * [Segundos formateado a HH:MM:SS]
 * @param {string} seconds [segundos]
 */
export function secondsToHumanTimeFormat(seconds) {
  let date = new Date(null);
  date.setSeconds(seconds);
  let result = date.toISOString().substr(11, 8);

  return HumanTimeFormat(result);
}

// /**
//  * [MM:SS formateado a Segundos]
//  * @param {string} minutes [minutos HH:SS]
//  */
// export function HumanTimeFormatToSeconds(seconds) {
//   let date = new Date(null);
//   date.setSeconds(seconds);
//   let result = date.toISOString().substr(11, 8);

//   return HumanTimeFormat(result);
// }
